<script lang="ts">
  import { page } from "$app/stores";

  import { Hamburger } from "svelte-hamburgers";

  import logotype from "$lib/assets/docs/logotype-docs.svg";
  import { isMobileMenuOpen } from "$lib/mobile-menu";
  import LoginSignupButtons from "$lib/ui/common/LoginSignupButtons.svelte";
  import Search from "./Search.svelte";
  import MobileMenuDropdown from "../marketing/MobileMenuDropdown.svelte";

  // /docs/guide, /docs/examples, /docs/reference are used as start_urls in
  // our Algolia Crawler defined in examples/10_integration/algolia_indexer.py
  // Careful before changing these!
  const links = [
    { href: "/docs/guide", name: "Guide" },
    { href: "/docs/examples", name: "Examples" },
    { href: "/docs/reference", name: "Reference" },
    { href: "/playground", name: "Playground" },
  ];
</script>

<div
  class="py-3 px-4 flex items-center gap-x-4 sm:gap-x-7 border-b border-c-gray-10"
>
  <a
    href="/docs"
    class="shrink-0 lg:mr-8"
    on:click={() => isMobileMenuOpen.set(false)}
  >
    <img src={logotype} alt="Modal logo" width="140px" />
  </a>

  <div class="h-full hidden md:flex items-center gap-7">
    {#each links as { href, name }}
      {@const active = $page.url.pathname.startsWith(href)}
      <a
        class="navlink relative text-sm text-c-gray-80 hover:text-c-green-100 transition-colors"
        {href}
        class:navlink-active={active}
        on:click={() => isMobileMenuOpen.set(false)}>{name}</a
      >
    {/each}
  </div>

  <div class="ml-auto">
    <Search indexName="modal_docs" placeholder="Search documentation" />
  </div>

  <div class="hidden md:block">
    <LoginSignupButtons />
  </div>

  <!-- Mobile animated hamburger menu -->
  <div class="block md:hidden text-c-gray-80">
    <Hamburger
      bind:open={$isMobileMenuOpen}
      --color="currentColor"
      --layer-height="1.5px"
      --layer-width="18px"
      --layer-spacing="5px"
      --padding="4px"
    />
  </div>

  <MobileMenuDropdown bind:open={$isMobileMenuOpen} {links} paddingTop="57px" />
</div>

<style lang="postcss">
  .navlink-active {
    @apply text-c-green-100;
  }

  .navlink::after {
    content: "";
    position: absolute;
    left: -3px;
    bottom: -17px;
    width: calc(100% + 6px);
    @apply border-b border-transparent transition-colors;
  }

  .navlink.navlink-active::after {
    @apply border-c-green-100;
  }
</style>
